function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#25AE88"
    },
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 38,15 22,33 12,25 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSvg);
export default __webpack_public_path__ + "static/media/success-Svg.2822d5c741dcf24e136036beb70c2cee.svg";
export { ForwardRef as ReactComponent };